import compact from 'lodash/compact';
import sortBy from 'lodash/sortBy';
import without from 'lodash/without';

import { IPolicyDocument, IRenewalOffer } from '../../../interfaces';

export type TCleanupPolicyDocuments = {
  documents: IPolicyDocument[];
  otherDocumentsOrder?: string[];
  renewalOffer?: IRenewalOffer;
  pinnedDocumentTypes: string[];
};

function cleanupPolicyDocuments({
  documents,
  otherDocumentsOrder = [],
  renewalOffer,
  pinnedDocumentTypes,
}: TCleanupPolicyDocuments) {
  const validDocuments = documents.filter(
    (doc) => !doc.replaced_at && doc.is_self_service_document
  );
  const pinnedDocuments = pinnedDocumentTypes.map((pinnedType) => {
    return validDocuments.find((doc) => doc.document_type === pinnedType);
  });

  const otherDocuments = sortBy(
    without(validDocuments, ...pinnedDocuments),
    function (document: IPolicyDocument) {
      const order = otherDocumentsOrder.findIndex(
        (document_type) => document.document_type === document_type
      );
      return order >= 0 ? order : validDocuments.length;
    }
  ) as IPolicyDocument[];
  const documentList = compact([...pinnedDocuments, ...otherDocuments]);
  const renewalDocuments = renewalOffer?.renewal_offer_documents || [];
  const validRenewalDocuments = renewalDocuments.filter(
    (doc) => doc.is_self_service_document
  );

  return {
    pinnedDocuments,
    otherDocuments,
    documentList,
    renewalDocuments: validRenewalDocuments,
  };
}

export default cleanupPolicyDocuments;
